import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

interface BreadcrumbItem {
  label: string;
  path?: string;
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
}

export default function Breadcrumb({ items }: BreadcrumbProps) {
  const { t } = useTranslation();

  const allItems: BreadcrumbItem[] = [
    { label: t('breadcrumb.home'), path: '/' },
    ...items,
  ];

  return (
    <nav aria-label="Breadcrumb" className="py-3 px-4 md:px-6">
      <ol className="flex flex-wrap items-center gap-1 text-sm">
        {allItems.map((item, index) => {
          const isLast = index === allItems.length - 1;
          return (
            <li key={index} className="flex items-center gap-1">
              {index > 0 && (
                <i className="ri-arrow-right-s-line text-foreground-400 text-xs"></i>
              )}
              {isLast ? (
                <span className="text-foreground-600 whitespace-nowrap">{item.label}</span>
              ) : (
                <Link
                  to={item.path || '/'}
                  className="text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer whitespace-nowrap"
                >
                  {item.label}
                </Link>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}